import Vec2 from 'vec2';

import { ChipMinimizerModel } from '../models';

import { useMouseEvents } from '~/UI/components/organisms/FabricCanvas/hooks/useMouseEvents';
import { useAppSelector } from '~/redux/hooks';
import { selectDraggedAppliance } from '~/redux/slices/draggedAppliance';

export const useDropAppliance = () => {
  const { createDropHandler } = useMouseEvents();
  const draggedAppliance = useAppSelector(selectDraggedAppliance);

  const resolveDropAppliance = (context: {
    chipMinimizer?: ChipMinimizerModel;
  }) => {
    const { chipMinimizer } = context;

    if (!draggedAppliance) {
      return;
    }
    const { appliance, centerPoint, targetShape, shapeId } = draggedAppliance;

    const onDropApplianceHandler = createDropHandler({
      appliance,
      shapeId,
      centerPoint: new Vec2(centerPoint.x, centerPoint.y),
      targetShape,
      hasChipMinimizer: !!chipMinimizer,
    });

    onDropApplianceHandler();
  };

  return { resolveDropAppliance };
};
